// updateUserErrorHandler.js

export function validateUpdateInput({ username, oldPassword, newPassword }) {
  const trimmedName = username?.trim() || "";

  const noNameChange = trimmedName.length === 0;
  const noPasswordChange = !oldPassword && !newPassword;

  if (noNameChange && noPasswordChange) {
    return "You didn't provide any data to update.";
  }

  if (newPassword && !oldPassword) {
    return "Please enter your current password to set a new one.";
  }

  if (oldPassword && !newPassword) {
    return "Please enter a new password to change it.";
  }

  if (newPassword && newPassword.length < 8) {
    return "New password should be at least 8 characters long.";
  }

  return null;
}

export function parseUpdateError(error) {
  const status = error?.status || error?.response?.status;
  const detail =
    error?.message ||
    error?.response?.data?.detail ||
    "Failed to update profile.";

  if (typeof detail === "string") {
    if (
      detail.toLowerCase().includes("old password") ||
      detail.toLowerCase().includes("current password")
    ) {
      return "Current password is incorrect.";
    }
  }

  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }

  switch (status) {
    case 400:
      return "Invalid data. Please check your input.";
    case 401:
      return "Your session has expired. Please sign in again.";
    case 403:
      return "You are not allowed to update this account.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please try again in a moment.";
    default:
      return "Could not update your profile. Please try again.";
  }
}
